import * as canvasActions from './actions';
import * as constants from '../utils/constants';

import {
  changeLogoEditingStatus,
  hideWaitingCover,
  setCurrentImprintAreaKey,
  setCurrentStep,
  showMessageBox,
  showWaitingCover,
  switchShowWarningMessageContainer,
} from '../main/actions';
import { configuratorStep, studioItemType as studioItemTypeEnum } from '../main/constants';
import { createMarginCover, getSortedElementList } from './components/Canvas/logics';
import { finalResizeWindow2, getResizeWindowInfo2 } from '../nextgen/canvas/logic';
import {
  getCanvasOverVignetteConfig,
  getCurrentImprintAreaKey,
  getItemUseScene7Template,
  getLogoEditingStatus,
  getShowVerticalRuler,
  getStudioItemType,
} from '../main/selectors';
import {
  getCanvasResizeInfo,
  getCurrentCanvasData,
  getItemStyleOriginSize,
  getSelectedImage,
  getTempLogo,
} from './selectors';
import {
  getRealPosToKeepElementInside,
  keepElementInCanvas,
  keepElementInSide,
  keepTextElementInCanvas,
} from '../elements/components/BaseElement/logics';
import { isIE, isMobileOnly } from 'react-device-detect';

import { TemplateType } from '../template/constants';
import { changeSidebarTabKey } from '../sidebar/actions';
import { deleteSavedArtImage } from './actions';
import { getDeviceViewPort } from '../utils/device';
import { getFinalTemplateSelection } from '../template/selectors';
import { getImprintAreaWidthRange } from '../imprintarea/selectors';
import { getIsNextGenUI } from '../nextgen/selectors';
import { getRectPointsCenter } from '../nextgen/elements/BaseElement/logics';
import { goToUpsellOrAddToCart } from '../main/logics';
import { isVectorImage } from '../utils/ImageUtils';

// restore autoCropRect/cropRect to origin state if not really cropped before addToCart
export const restoreCropRect = (imageData, imageUi) => {
  // not restore original cropRect because Sharpen process may change it

  // // if the logo is from recentArt, autoCropRectOrigin/cropRectOrigin are in imageData
  // const originSource = imageData.originalOptions && imageData.originalOptions.autoCropRectOrigin ? imageData : imageUi;

  // if (imageData.type === constants.userImageType.UploadLogo) {
  //   if (!imageData.isAutoCropped) {
  //     imageData.autoCropRect = {
  //       x: originSource.originalOptions.autoCropRectOrigin.x,
  //       y: originSource.originalOptions.autoCropRectOrigin.y,
  //       width: originSource.originalOptions.autoCropRectOrigin.width,
  //       height: originSource.originalOptions.autoCropRectOrigin.height,
  //     };
  //   }
  //   if (!imageData.isCropped) {
  //     imageData.cropRect = {
  //       x: originSource.originalOptions.cropRectOrigin.x,
  //       y: originSource.originalOptions.cropRectOrigin.y,
  //       width: originSource.originalOptions.cropRectOrigin.width,
  //       height: originSource.originalOptions.cropRectOrigin.height,
  //     };
  //   }
  // }
  return imageData;
};

//prepare necessary properties for logo/art (such as id) before adding a new element
export const addNewElement = (addNewElementAction, newArtData) => (dispatch, getState) => {
  const studioItemType = getStudioItemType(getState());
  if (studioItemType !== studioItemTypeEnum.nonDigital && newArtData) {
    if (newArtData.type !== constants.userImageType.SharedArt && newArtData.type !== constants.userImageType.StockArt) {
      if (typeof newArtData.width === 'undefined' || typeof newArtData.height === 'undefined') {
        dispatch(showMessageBox(constants.ART_NOT_AVAILABLE));
        return;
      }
    }
  }

  const canvasData = getCurrentCanvasData(getState());
  const id = getItemElementId(canvasData);
  const layerIndex = getImageLayerIndex(canvasData, true);
  addNewElementAction(id, layerIndex);
};

export const addNewElementForText = (addNewElementAction) => (dispatch, getState) => {
  const canvasData = getCurrentCanvasData(getState());
  const id = getItemElementId(canvasData);
  const layerIndex = getImageLayerIndex(canvasData, false);
  addNewElementAction(id, layerIndex);
};

export const addLogoToRecent = (addRecentAction) => (dispatch, getState) => {
  // get the updated new image data for recent
  const state = getState();
  let updatedImage = getSelectedImage(state);
  const itemUseScene7Template = getItemUseScene7Template(state);

  // if non-digital new logo, its status is TempSelected
  if (typeof updatedImage === 'undefined') updatedImage = getTempLogo(getState());

  const newImageData = {};
  Object.assign(newImageData, updatedImage.data, { originalOptions: {} });
  newImageData.itemUseScene7Template = itemUseScene7Template;

  newImageData.originalOptions.autoCropRectOrigin = updatedImage.ui.originalOptions.autoCropRectOrigin;
  newImageData.originalOptions.cropRectOrigin = updatedImage.ui.originalOptions.cropRectOrigin;
  newImageData.originalOptions.finalCropRectOrigin = updatedImage.ui.originalOptions.finalCropRectOrigin;
  addRecentAction(newImageData);
};

export const restoreOriginCropForUploadLogo = (logoImage) => {
  logoImage.ui.originalOptions.autoCropRectOrigin = logoImage.data.originalOptions.autoCropRectOrigin;
  logoImage.ui.originalOptions.cropRectOrigin = logoImage.data.originalOptions.cropRectOrigin;
  logoImage.ui.originalOptions.finalCropRectOrigin = logoImage.data.originalOptions.finalCropRectOrigin;
  delete logoImage.data.originalOptions.autoCropRectOrigin;
  delete logoImage.data.originalOptions.cropRectOrigin;
  delete logoImage.data.originalOptions.finalCropRectOrigin;
};

export const getItemElementId = (canvasData) => {
  const getMinElementId = (elements) => {
    let elementId = Number.MAX_SAFE_INTEGER;
    elements.forEach((element) => {
      elementId = Math.min(element.data.itemElementId || 0, elementId);
    });
    return elementId;
  };

  let id1 = 0,
    id2 = 0;
  if (canvasData.imageList && canvasData.imageList.length > 0) id1 = getMinElementId(canvasData.imageList) - 1;
  id1 = Math.min(0, id1);

  if (canvasData.textList && canvasData.textList.length > 0) id2 = getMinElementId(canvasData.textList) - 1;

  return Math.min(id1, id2);
};

export const getImageLayerIndex = (canvasData, isImage) => {
  let maxIndex = 0;
  if (isImage) {
    if (canvasData.imageList && canvasData.imageList.length > 0){
      maxIndex =
        canvasData.imageList.reduce(
          (max, el) => (el.data.zIndex > max ? el.data.zIndex : max),
          Number.MIN_SAFE_INTEGER
        ) + 1;
      maxIndex = Math.max(maxIndex, constants.IMAGE_ELEMENT_INIT_ZINDEX);
    }
    else maxIndex = constants.IMAGE_ELEMENT_INIT_ZINDEX;
  } else {
    if (canvasData.textList && canvasData.textList.length > 0) {
      maxIndex =
        canvasData.textList.reduce(
          (max, el) => (el.data.zIndex > max ? el.data.zIndex : max),
          Number.MIN_SAFE_INTEGER
        ) + 1;
      maxIndex = Math.max(maxIndex, constants.TEXT_ELEMENT_INIT_ZINDEX);
    }
    else maxIndex = constants.TEXT_ELEMENT_INIT_ZINDEX;
  }
  return maxIndex;
};

export const getLimitedAndRepositionedElementRect = (elementData, draggingArea) => {
  let newSize = { width: elementData.width, height: elementData.height };

  if (elementData.direction === 0 || elementData.direction === 180) {
    if (elementData.width > draggingArea.width || elementData.height > draggingArea.height) {
      newSize = adjustImageSizeToFitContainer(
        { width: elementData.width, height: elementData.height },
        { width: draggingArea.width, height: draggingArea.height }
      );
    }
  } else {
    //90 or 270
    if (elementData.width > draggingArea.height || elementData.height > draggingArea.width) {
      newSize = adjustImageSizeToFitContainer(
        { width: elementData.width, height: elementData.height },
        { width: draggingArea.height, height: draggingArea.width }
      );
    }
  }

  let adjustedElement = keepElementInCanvas(
    draggingArea,
    { x: elementData.x, y: elementData.y },
    { width: newSize.width, height: newSize.height },
    elementData.direction
  );

  adjustedElement = keepElementInSide(
    draggingArea,
    { x: adjustedElement.x, y: adjustedElement.y },
    { width: adjustedElement.width, height: adjustedElement.height },
    elementData.direction,
    constants.elementType.Image
  );

  return adjustedElement;
};

export const getTextLimitedAndRepositionedElementRect = (element, draggingArea) => {
  let newSize = { width: element.ui.outlineRect.width, height: element.ui.outlineRect.height };
  if (newSize.width > draggingArea.width || newSize.height > draggingArea.height) {
    newSize = adjustImageSizeToFitContainer(
      { width: newSize.width, height: newSize.height },
      { width: draggingArea.width, height: draggingArea.height }
    );
  }
  let adjustedElement = keepTextElementInCanvas(draggingArea, element, {
    width: newSize.width,
    height: newSize.height,
  });

  const realPos = getRealPosToKeepElementInside(
    draggingArea,
    { x: adjustedElement.x, y: adjustedElement.y },
    { width: element.data.width, height: element.data.height },
    element.data.direction,
    constants.elementType.Text
  );
  adjustedElement.x = realPos.x;
  adjustedElement.y = realPos.y;
  return adjustedElement;
};

// resize the old size to just fit the container and keep the ratio
export const adjustImageSizeToFitContainer = (imageSize, containerSize) => {
  if (typeof imageSize.height === 'undefined' || isNaN(imageSize.height) || imageSize.height === 0)
    return containerSize;

  let newWidth = 0.0;
  let newHeight = 0.0;
  const ratio = imageSize.width / imageSize.height;
  if (containerSize.width > containerSize.height) {
    newHeight = containerSize.height;
    newWidth = containerSize.height * ratio;
    if (newWidth > containerSize.width) {
      newWidth = containerSize.width;
      newHeight = containerSize.width / ratio;
    }
  } else {
    newWidth = containerSize.width;
    newHeight = containerSize.width / ratio;
    if (newHeight > containerSize.height) {
      newHeight = containerSize.height;
      newWidth = containerSize.height * ratio;
    }
  }

  return { width: Math.round(newWidth), height: Math.round(newHeight) };
};

export const calculateCanvasAreaPosition = () => {
  const canvasContainer = document.getElementById(constants.domNodeId.canvasContainer);
  if (!canvasContainer) return { left: 0, top: 0 };
  
  const paddingTop = parseInt(window.getComputedStyle(canvasContainer).paddingTop);
  const clientRect = canvasContainer.getBoundingClientRect();

  let left, top;
  if (isIE) {
    left = clientRect.left + window.pageXOffset;
    top = clientRect.top + window.pageYOffset;
  } else {
    left = clientRect.left + window.scrollX;
    top = clientRect.top + window.scrollY;
  }
  return { left, top: top + paddingTop };
};

export const limitAndRepositionElement = (elementData, draggingArea) => {
  const result = getLimitedAndRepositionedElementRect(elementData, draggingArea);

  elementData.x = result.x;
  elementData.y = result.y;
  elementData.width = result.width;
  elementData.height = result.height;
};

export const limitAndRepositionTextElement = (element, draggingArea) => {
  const result = getTextLimitedAndRepositionedElementRect(element, draggingArea);
  return result;
};

export const convertToOriginalScale = function (realPos, scale) {
  // return new object because Konva may change the property values of the original object
  return { x: realPos.x / scale, y: realPos.y / scale };
};

export const convertToRealScale = function (originalPos, scale) {
  // return new object because Konva may change the property values of the original object
  return { x: originalPos.x * scale, y: originalPos.y * scale };
};

export const getResizeWindowInfo = (canvasKey, canvasData, state) => {
  const hasVerticalRuler = getShowVerticalRuler(state);
  const imprintAreaWidthRange = getImprintAreaWidthRange(state, canvasKey);

  const canvasWidthRange = getCanvasWidthRange(canvasData, imprintAreaWidthRange);
  const originCanvasWidth = canvasData.fullWidth;
  const viewPortWidth = getDeviceViewPort().width;
  const step2ContainerMargin = viewPortWidth * 0.02 * 2; //.main-step2, marginLeft/marginRight=2%
  const extraSize1 = 30;
  const extraSize2 = 20;
  const extraSize3 = 20;

  const canvasWidthMax = canvasWidthRange.max;
  const canvasWidthMin = canvasWidthRange.min;

  let canvasScale = 1;
  let resizingPhase;
  let sideBarWidth;
  let canvasAreaWidth;
  const fixedWidth1 =
    extraSize1 +
    step2ContainerMargin +
    constants.SIDE_BAR_TAB_WIDTH +
    constants.MAX_SIDE_BAR_WIDTH +
    constants.PREVIEW_WIDTH +
    constants.CANVAS_MARGIN * 2;
  const fixedWidth2 =
    extraSize2 + step2ContainerMargin + constants.SIDE_BAR_TAB_WIDTH + canvasWidthMax + constants.CANVAS_MARGIN;
  const fixedWidth3 = extraSize3 + step2ContainerMargin + constants.SIDE_BAR_TAB_WIDTH + constants.CANVAS_MARGIN;

  if (viewPortWidth - fixedWidth1 > canvasWidthMax) {
    resizingPhase = constants.canvasResizingPhase.OneRowAndNoResizing;
    sideBarWidth = constants.MAX_SIDE_BAR_WIDTH;
    canvasAreaWidth = canvasWidthMax;
  } else if (viewPortWidth - fixedWidth1 > canvasWidthMin) {
    resizingPhase = constants.canvasResizingPhase.OneRowAndResizingCanvas;
    sideBarWidth = constants.MAX_SIDE_BAR_WIDTH;
    canvasAreaWidth = viewPortWidth - fixedWidth1;
  } else if (viewPortWidth - fixedWidth2 > constants.MAX_SIDE_BAR_WIDTH) {
    resizingPhase = constants.canvasResizingPhase.TwoRowsAndNoResizing;
    sideBarWidth = constants.MAX_SIDE_BAR_WIDTH;
    canvasAreaWidth = canvasWidthMax;
  } else if (viewPortWidth - fixedWidth2 > constants.MIN_SIDE_BAR_WIDTH) {
    resizingPhase = constants.canvasResizingPhase.TwoRowsAndResizingSideBar;
    canvasAreaWidth = canvasWidthMax;
    sideBarWidth = viewPortWidth - fixedWidth2;
  } else if (viewPortWidth - fixedWidth3 - constants.MIN_SIDE_BAR_WIDTH > canvasWidthMin) {
    resizingPhase = constants.canvasResizingPhase.TwoRowsAndResizingCanvas;
    sideBarWidth = constants.MIN_SIDE_BAR_WIDTH;
    canvasAreaWidth = viewPortWidth - fixedWidth3 - constants.MIN_SIDE_BAR_WIDTH;
  } else {
    resizingPhase = constants.canvasResizingPhase.ThreeRows;
    sideBarWidth = Math.max(
      constants.MIN_SIDE_BAR_WIDTH,
      Math.min(constants.MAX_SIDE_BAR_WIDTH, viewPortWidth - constants.SIDE_BAR_TAB_WIDTH)
    );
    canvasAreaWidth = Math.min(canvasWidthMax, Math.max(canvasWidthMin, viewPortWidth - step2ContainerMargin));
  }

  // force canvasWidth to device clientWidth for mobile(consider the extra margin)
  if (isMobileOnly) {
    canvasAreaWidth =
      ((viewPortWidth - constants.MOBILE_CANVAS_MARGIN) * originCanvasWidth) /
      (originCanvasWidth + (canvasData.extraMarginX ? canvasData.extraMarginX : 0) * 2);
    if (hasVerticalRuler) {
      canvasAreaWidth =
        ((viewPortWidth -
          constants.MAX_RULERLINE_LENGTH -
          constants.MAX_RULERTEXT_LENGTH -
          constants.RULER_LEFT_MARGIN -
          constants.MOBILE_CANVAS_MARGIN) *
          originCanvasWidth) /
        (originCanvasWidth + (canvasData.extraMarginX ? canvasData.extraMarginX : 0) * 2);
    }
  }

  // note that canvasAreaWidth may be larger than canvasWidthRange.max
  if (canvasAreaWidth > canvasWidthRange.max) canvasAreaWidth = canvasWidthRange.max;

  // limit the scale
  if (canvasAreaWidth / originCanvasWidth < constants.MAX_CANVAS_SCALE) {
    canvasScale = canvasAreaWidth / originCanvasWidth;
  } else {
    canvasScale = constants.MAX_CANVAS_SCALE;
    canvasAreaWidth = constants.MAX_CANVAS_SCALE * originCanvasWidth;
  }

  return { canvasAreaWidth, resizingPhase, sideBarWidth, canvasScale };
};

export const getVignetteCanvasInfo = (canvasOverVignetteConfig) => {
  let vignetteImageWidth, vignetteImageHeight;
  if (canvasOverVignetteConfig.defaultVignetteWidth > canvasOverVignetteConfig.defaultVignetteHeight) {
    vignetteImageWidth = constants.DEFAULT_SUPERIMPOSED_VIGNETTE_SIZE;
    vignetteImageHeight =
      canvasOverVignetteConfig.defaultVignetteHeight *
      (vignetteImageWidth / canvasOverVignetteConfig.defaultVignetteWidth);
  } else {
    vignetteImageHeight = constants.DEFAULT_SUPERIMPOSED_VIGNETTE_SIZE;
    vignetteImageWidth =
      canvasOverVignetteConfig.defaultVignetteWidth *
      (vignetteImageHeight / canvasOverVignetteConfig.defaultVignetteHeight);
  }

  let canvasRate, canvasConfigType, vignetteTotalWidth;
  if (
    canvasOverVignetteConfig.canvasX < 0 &&
    canvasOverVignetteConfig.canvasX + canvasOverVignetteConfig.canvasWidth > vignetteImageWidth
  ) {
    vignetteTotalWidth = canvasOverVignetteConfig.canvasWidth;
    canvasConfigType = constants.vignetteCanvasConfigType.LeftRightOut;
  } else if (canvasOverVignetteConfig.canvasX < 0) {
    vignetteTotalWidth = Math.abs(canvasOverVignetteConfig.canvasX) + vignetteImageWidth;
    canvasConfigType = constants.vignetteCanvasConfigType.LeftOut;
  } else if (canvasOverVignetteConfig.canvasX + canvasOverVignetteConfig.canvasWidth > vignetteImageWidth) {
    vignetteTotalWidth = canvasOverVignetteConfig.canvasX + canvasOverVignetteConfig.canvasWidth;
    canvasConfigType = constants.vignetteCanvasConfigType.RightOut;
  } else {
    vignetteTotalWidth = vignetteImageWidth;
    canvasConfigType = constants.vignetteCanvasConfigType.Inside;
  }

  canvasRate = canvasOverVignetteConfig.canvasWidth / vignetteTotalWidth;
  const vignetteImageRate = vignetteImageWidth / vignetteTotalWidth;

  return {
    vignetteTotalWidth,
    vignetteImageRate,
    canvasRate,
    canvasConfigType,
    vignetteImageHeight,
    vignetteImageWidth,
    showBackgroundColor: canvasOverVignetteConfig.showBackgroundColor,
  };
};

export const resizeWindow = (canvasKey) => (dispatch, getState) => {
  const state = getState();
  const canvasData = getCurrentCanvasData(state, canvasKey);
  if (!canvasData.fullWidth) {
    //canvas constant is not ready, exit
    return;
  }
  const imprintAreaKey = canvasKey || getCurrentImprintAreaKey(state);
  const canvasOverVignetteConfig = getCanvasOverVignetteConfig(state);
  const canvasResizeInfo = getCanvasResizeInfo(state); // canvasResizeInfo can be empty at beginning
  const studioItemType = getStudioItemType(state);
  const nextGenUI = getIsNextGenUI(state);
  const itemStyleOriginSize = getItemStyleOriginSize(state);

  const resizeWindowInfo = nextGenUI
    ? getResizeWindowInfo2(canvasData)
    : getResizeWindowInfo(canvasKey, canvasData, state);
  if (resizeWindowInfo === null) return;

  const resizingPhase = resizeWindowInfo.resizingPhase;
  const sideBarWidth = resizeWindowInfo.sideBarWidth;
  let canvasAreaWidth = resizeWindowInfo.canvasAreaWidth;
  let scale = resizeWindowInfo.canvasScale;

  nextGenUI
    ? finalResizeWindow2({
        canvasAreaWidth,
        studioItemType,
        canvasOverVignetteConfig,
        canvasResizeInfo,
        dispatch,
        imprintAreaKey,
        sideBarWidth,
        itemStyleOriginSize,
        canvasData,
      })
    : finalResizeWindow({
        canvasAreaWidth,
        studioItemType,
        canvasOverVignetteConfig,
        canvasResizeInfo,
        scale,
        dispatch,
        imprintAreaKey,
        resizingPhase,
        sideBarWidth,
      });
};

const finalResizeWindow = ({
  canvasAreaWidth,
  studioItemType,
  canvasOverVignetteConfig,
  canvasResizeInfo,
  scale,
  dispatch,
  imprintAreaKey,
  resizingPhase,
  sideBarWidth,
}) => {
  const availableCanvasAreaWidth = canvasAreaWidth;
  if (
    studioItemType !== studioItemTypeEnum.nonDigital &&
    canvasOverVignetteConfig.vignette &&
    canvasOverVignetteConfig.canvasWidth > 0
  ) {
    const vignetteCanvasInfo = getVignetteCanvasInfo(canvasOverVignetteConfig);
    scale = scale * vignetteCanvasInfo.canvasRate;

    const actualCanvasWidth = availableCanvasAreaWidth * vignetteCanvasInfo.canvasRate;
    canvasAreaWidth = actualCanvasWidth;
    dispatch(
      canvasActions.changeCanvasResizeParameters({
        imprintAreaKey,
        availableCanvasAreaWidth,
      })
    );
  }

  if (canvasResizeInfo && canvasResizeInfo.canvasZoom > 0) {
    const canvasZoom = 1 + canvasResizeInfo.canvasZoom / 100;
    scale = scale * canvasZoom;
    canvasAreaWidth = canvasAreaWidth * canvasZoom;
  }

  dispatch(
    canvasActions.changeCanvasResizeParameters({
      imprintAreaKey,
      resizingPhase,
      sideBarWidth,
      canvasWidth: canvasAreaWidth,
      scale,
    })
  );
  createMarginCover();
};

export const getCanvasWidthRange = (canvasData, imprintAreaWidthRange) => {
  // if canvas max/min size is configured in admin tools
  let sizeConfigured = false;
  if (
    imprintAreaWidthRange !== null &&
    imprintAreaWidthRange.maxDisplayWidth &&
    imprintAreaWidthRange.minDisplayWidth
  ) {
    sizeConfigured = true;
  }
  let maxCanvasWidth = sizeConfigured ? imprintAreaWidthRange.maxDisplayWidth : constants.MAX_CANVAS_SIZE;
  let minCanvasWidth = sizeConfigured ? imprintAreaWidthRange.minDisplayWidth : constants.MIN_CANVAS_SIZE;
  const canvasWidth = canvasData.fullWidth;
  const canvasHeight = canvasData.fullHeight;

  if (!sizeConfigured) {
    // adjust max/min size by checking it's tall or wide canvas when the size is not configured in admin tools
    if (canvasHeight > canvasWidth) {
      maxCanvasWidth = Math.round((constants.MAX_CANVAS_SIZE / canvasHeight) * canvasWidth);
      minCanvasWidth = Math.round((constants.MIN_CANVAS_SIZE / canvasHeight) * canvasWidth);
    }
  }

  return { max: maxCanvasWidth, min: minCanvasWidth };
};

export const consoleLog = (err) => {
  if (err) {
    console.log(err.message || '');
    console.log('Stack: ');
    console.log(err.stack);
    console.log('Response: ');
    console.log(err.response);
  }
};

const calcElemenListAfterRotate = (elementList) => {
  let elementListAfterRotate = JSON.parse(JSON.stringify(elementList));
  elementListAfterRotate.forEach((item) => {
    const originalData = JSON.parse(JSON.stringify(item.data));
    switch (item.data.direction) {
      case constants.rotateDirectionEnum.degrees90:
        item.data.x = originalData.x - originalData.height;
        item.data.width = originalData.height;
        item.data.height = originalData.width;
        break;
      case constants.rotateDirectionEnum.degrees180:
        item.data.x = originalData.x - originalData.width;
        item.data.y = originalData.y - originalData.height;
        break;
      case constants.rotateDirectionEnum.degrees270:
        item.data.y = originalData.y - originalData.width;
        item.data.width = originalData.height;
        item.data.height = originalData.width;
        break;
      default:
        break;
    }
  });
  return elementListAfterRotate;
};

const calcInterval = (el1, el2) => (dispatch, getState) => {
  const state = getState();
  const canvasData = getCurrentCanvasData(state);
  const minDistance = Math.round(canvasData.previewResolution * (1 / 16));
  const topMost1 = el1.y;
  const bottomMost1 = el1.y + el1.height;
  const topMost2 = el2.y;
  const bottomMost2 = el2.y + el2.height;
  const leftMost1 = el1.x;
  const rightMost1 = el1.x + el1.width;
  const leftMost2 = el2.x;
  const rightMost2 = el2.x + el2.width;
  const illegalDistance =
    topMost1 - bottomMost2 < minDistance &&
    topMost2 - bottomMost1 < minDistance &&
    leftMost1 - rightMost2 < minDistance &&
    leftMost2 - rightMost1 < minDistance;
  return illegalDistance;
};

export const isIntervalInvalid = (isTemplateEditor) => (dispatch, getState) => {
  const state = getState();
  let illegalDistance = false;
  const canvasData = getCurrentCanvasData(state);
  const canvasKey = getCurrentImprintAreaKey(state);
  const imageList = canvasData.imageList;
  let textList = canvasData.textList;
  if (!isTemplateEditor) textList = canvasData.textList.filter((item) => item.data.imprintText !== '');
  const elementList = getSortedElementList(textList, imageList);
  const elementListAfterRotate = calcElemenListAfterRotate(elementList);

  for (const index1 in elementListAfterRotate) {
    if (illegalDistance) break;
    for (const index2 in elementListAfterRotate) {
      if (
        index1 !== index2 &&
        dispatch(calcInterval(elementListAfterRotate[index1].data, elementListAfterRotate[index2].data))
      ) {
        illegalDistance = true;
        dispatch(canvasActions.unSelectAllImage({ canvasKey }));
        dispatch(canvasActions.unSelectAllText({ canvasKey }));

        if (elementList[index1].data.fontSize)
          dispatch(canvasActions.selectText({ canvasKey, imageId: elementList[index1].ui.guid }));
        else dispatch(canvasActions.selectImage({ canvasKey, imageId: elementList[index1].ui.guid }));

        dispatch(canvasActions.setCanvasElementHighlight({ canvasKey, guid: elementList[index1].ui.guid }));
        dispatch(canvasActions.setCanvasElementHighlight({ canvasKey, guid: elementList[index2].ui.guid }));
        break;
      }
    }
  }
  return illegalDistance;
};

export const deleteSavedArtImageAsync = () => (dispatch) => {
  dispatch(deleteSavedArtImage());
};

export const adjustLogoOriginSizeByLimitation = (imageData, studioItemType, draggingArea) => {
  if (studioItemType === studioItemTypeEnum.digital || studioItemType === studioItemTypeEnum.screenPrintedDigital) {
    if (
      imageData.width > draggingArea.width * constants.ART_INIT_SIZE_PERCENT ||
      imageData.height > draggingArea.height * constants.ART_INIT_SIZE_PERCENT
    ) {
      const newSize = adjustImageSizeToFitContainer(
        { width: imageData.width, height: imageData.height },
        {
          width: draggingArea.width * constants.ART_INIT_SIZE_PERCENT,
          height: draggingArea.height * constants.ART_INIT_SIZE_PERCENT,
        }
      );
      imageData.width = newSize.width;
      imageData.height = newSize.height;
    }

    if (imageData.width < constants.MIN_ART_INIT_SIZE || imageData.height < constants.MIN_ART_INIT_SIZE) {
      const newSize = adjustImageSizeToFitContainer(
        { width: imageData.width, height: imageData.height },
        {
          width: constants.MIN_ART_INIT_SIZE,
          height: constants.MIN_ART_INIT_SIZE,
        }
      );
      imageData.width = newSize.width;
      imageData.height = newSize.height;
    }

    const newSize = adjustImageSizeToFitContainer(
      { width: imageData.width, height: imageData.height },
      {
        width: draggingArea.width * constants.ART_INIT_SIZE_PERCENT,
        height: draggingArea.height * constants.ART_INIT_SIZE_PERCENT,
      }
    );
    imageData.width = newSize.width;
    imageData.height = newSize.height;
  }
};

export const initOriginalOptions = (imageElement, imageData) => {
  imageElement.ui.originalOptions = {};
  imageElement.ui.originalOptions.autoCropRectOrigin = Object.assign({}, imageData.autoCropRect);
  imageElement.ui.originalOptions.cropRectOrigin = Object.assign({}, { x: 0, y: 0, width: 0, height: 0 });
  imageElement.ui.originalOptions.finalCropRectOrigin = Object.assign({}, imageData.autoCropRect);
};

export const resizeText = (outlineRect, noRotateRect, resizeRatio, degree) => {
  if (resizeRatio === 1) return null;
  const newNoRotateRect = getNoRotateRectAfterResize(noRotateRect, resizeRatio);
  const result = getRotateResult(getRectPoints(newNoRotateRect), degree);
  const offset = { x: result.outlineRect.x - outlineRect.x, y: result.outlineRect.y - outlineRect.y };
  return {
    outlineRect: {
      x: outlineRect.x,
      y: outlineRect.y,
      width: result.outlineRect.width,
      height: result.outlineRect.height,
    },
    rotatedRectPoints: [
      { x: result.rotatedRectPoints[0].x - offset.x, y: result.rotatedRectPoints[0].y - offset.y },
      { x: result.rotatedRectPoints[1].x - offset.x, y: result.rotatedRectPoints[1].y - offset.y },
      { x: result.rotatedRectPoints[2].x - offset.x, y: result.rotatedRectPoints[2].y - offset.y },
      { x: result.rotatedRectPoints[3].x - offset.x, y: result.rotatedRectPoints[3].y - offset.y },
    ],
    noRotateRect: {
      x: newNoRotateRect.x - offset.x,
      y: newNoRotateRect.y - offset.y,
      width: newNoRotateRect.width,
      height: newNoRotateRect.height,
    },
  };
};

export const getNoRotateRectAfterResize = (noRotateRect, resizeRatio) => {
  let newNoRotateRect = { ...noRotateRect };
  newNoRotateRect.width *= resizeRatio;
  newNoRotateRect.height *= resizeRatio;
  return newNoRotateRect;
};

export const rotateText = (rectPoints, degree) => {
  const result = getRotateResult(rectPoints, degree);
  return { rotatedRectPoints: result.rotatedRectPoints, outlineRect: result.outlineRect };
};

export const rotateElement = (rectPoints, degree) => {
  const result = getRotateResult(rectPoints, degree);
  return { rotatedRectPoints: result.rotatedRectPoints, outlineRect: result.outlineRect };
};

export const getRotatedPointsCenter = (rectPoints) => {
  const x = (rectPoints[0].x + rectPoints[2].x) / 2;
  const y = (rectPoints[0].y + rectPoints[2].y) / 2;
  return { x, y };
};

export const getOutlineCenter = (rectPoints) => {
  const outlineRect = getOutlineRect(rectPoints);
  const x = outlineRect.x + outlineRect.width / 2;
  const y = outlineRect.y + outlineRect.height / 2;
  return { x, y };
};

export const getMidPoint = (p1, p2) => {
  return { x: (p1.x + p2.x) / 2, y: (p1.y + p2.y) / 2 };
};

export const getDistance = (p1, p2) => {
  return Math.hypot(Math.abs(p1.x - p2.x), Math.abs(p1.y - p2.y));
};

export const getRectPoints = (rect) => {
  return [
    { x: rect.x, y: rect.y },
    { x: rect.x + rect.width, y: rect.y },
    { x: rect.x + rect.width, y: rect.y + rect.height },
    { x: rect.x, y: rect.y + rect.height },
  ];
};

export const rotateByCenterPoint = (rectPoints, centerPoint, degree) => {
  const rotatedRectPoints = [];
  rectPoints.forEach((rectPoint) => {
    const cartPoint = toCartesian(rectPoint, centerPoint);
    const rotatedPoint = rotatePoint(cartPoint, degree);
    rotatedRectPoints.push(toScreen(rotatedPoint, centerPoint));
  });
  return rotatedRectPoints;
};

export const toCartesian = (rectPoint, centerPoint) => {
  return { x: rectPoint.x - centerPoint.x, y: -(rectPoint.y - centerPoint.y) };
};

export const degreeToRadian = (degree) => {
  return (degree * Math.PI) / 180;
};

export const rotatePoint = (point, degree) => {
  const angle = degreeToRadian(degree);
  return {
    x: point.x * Math.cos(angle) - point.y * Math.sin(angle),
    y: point.y * Math.cos(angle) + point.x * Math.sin(angle),
  };
};

export const dragTextCornerResult = (noRotateRect, pos, corners, dragCornerIdx, degree, centerPoint) => {
  // -- opposite: opposite corner of the dragging corner, which will be fixed
  const oppositeIndex = (dragCornerIdx + 2) % 4;

  const originalDiagLen = getDistance(corners[dragCornerIdx], corners[oppositeIndex]); //Math.hypot(originalWidth, originalHeight);
  const newDiagLen = getDistance(pos, corners[oppositeIndex]);
  // use scale to make sure width&height ratio as the same
  const resizeRatio = newDiagLen / originalDiagLen;

  let newWidth = noRotateRect.width * resizeRatio;
  let newHeight = noRotateRect.height * resizeRatio;

  const rectPoints = getRectPoints(noRotateRect);

  let newRecPoints = [];

  const fixedPoint = rectPoints[oppositeIndex];
  if (dragCornerIdx === 0) {
    newRecPoints = [
      { x: fixedPoint.x - newWidth, y: fixedPoint.y - newHeight },
      { x: fixedPoint.x, y: fixedPoint.y - newHeight },
      { x: fixedPoint.x, y: fixedPoint.y },
      { x: fixedPoint.x - newWidth, y: fixedPoint.y },
    ];
  } else if (dragCornerIdx === 1) {
    newRecPoints = [
      { x: fixedPoint.x, y: fixedPoint.y - newHeight },
      { x: fixedPoint.x + newWidth, y: fixedPoint.y - newHeight },
      { x: fixedPoint.x + newWidth, y: fixedPoint.y },
      { x: fixedPoint.x, y: fixedPoint.y },
    ];
  } else if (dragCornerIdx === 2) {
    newRecPoints = [
      { x: fixedPoint.x, y: fixedPoint.y },
      { x: fixedPoint.x + newWidth, y: fixedPoint.y },
      { x: fixedPoint.x + newWidth, y: fixedPoint.y + newHeight },
      { x: fixedPoint.x, y: fixedPoint.y + newHeight },
    ];
  } else if (dragCornerIdx === 3) {
    newRecPoints = [
      { x: fixedPoint.x - newWidth, y: fixedPoint.y },
      { x: fixedPoint.x, y: fixedPoint.y },
      { x: fixedPoint.x, y: fixedPoint.y + newHeight },
      { x: fixedPoint.x - newWidth, y: fixedPoint.y + newHeight },
    ];
  }

  const newUnrotatedRect = {
    x: newRecPoints[0].x,
    y: newRecPoints[0].y,
    width: newWidth,
    height: newHeight,
  };

  const newRotatedPoints = rotateByCenterPoint(newRecPoints, centerPoint, -degree);

  const newCenterPoint = getOutlineCenter(newRotatedPoints);
  const newUnrotatedRectPoints = rotateByCenterPoint(newRotatedPoints, newCenterPoint, degree);
  const finalRect = {
    x: newUnrotatedRectPoints[0].x,
    y: newUnrotatedRectPoints[0].y,
    width: newWidth,
    height: newHeight,
  };

  //newX, newY is the orignal top-left corner rotated position
  // newX = index === 2 ? corners[0].x : corners[0].x + (pos.x - corners[index].x);
  // newY = index === 2 ? corners[0].y : corners[0].y + (pos.y - corners[index].y);
  const newOutlineRect = { x: newRotatedPoints[0].x, y: newRotatedPoints[0].y, width: newWidth, height: newHeight };

  const result = {
    outlineRect: newOutlineRect,
    rotatedRectPoints: newRotatedPoints,
    noRotateRect: newUnrotatedRect,
    finalRotateRect: finalRect,
  };

  return result;
};

export const toScreen = (rotatedPoint, centerPoint) => {
  return { x: centerPoint.x + rotatedPoint.x, y: centerPoint.y - rotatedPoint.y };
};

export const getOutlineRect = (rotatedRectPoints) => {
  const partListX = [];
  const partListY = [];
  rotatedRectPoints.forEach((point) => {
    partListX.push(point.x);
    partListY.push(point.y);
  });
  const minX = Math.min(...partListX);
  const minY = Math.min(...partListY);
  const maxX = Math.max(...partListX);
  const maxY = Math.max(...partListY);
  return { x: minX, y: minY, width: maxX - minX, height: maxY - minY };
};

export const getRotateResult = (rectPoints, degree, centerPoint) => {
  centerPoint = centerPoint || getRectPointsCenter(rectPoints);
  const rotatedRectPoints = rotateByCenterPoint(rectPoints, centerPoint, degree);
  const outlineRect = getOutlineRect(rotatedRectPoints);
  return { rotatedRectPoints, outlineRect };
};

export const checkBackgroundImageDpi = ({
  dispatch,
  returnStatus,
  canvasData,
  imageData,
  isCropBackground,
  isNewUploaded,
  checkOnly,
}) => {
  if (constants.disableCheckLowDpi) return false;
  if (isVectorImage(imageData.fileName)) return false;

  let lowWidthDpi = false;
  let lowHeightDpi = false;

  if (Math.ceil(imageData.logoResolutionX) < constants.MIN_CANVAS_DPI) lowWidthDpi = true;
  if (Math.ceil(imageData.logoResolutionY) < constants.MIN_CANVAS_DPI) lowHeightDpi = true;

  let backgroundWidth = 0,
    backgroundHeight = 0;

  if (imageData.finalCropRect && imageData.finalCropRect.width && imageData.finalCropRect.height) {
    backgroundWidth = imageData.finalCropRect.width;
    backgroundHeight = imageData.finalCropRect.height;
  } else {
    backgroundWidth = imageData.originalWidth;
    backgroundHeight = imageData.originalHeight;
  }

  if (!lowWidthDpi) {
    const canvasWidthInInch = canvasData.fullWidth / canvasData.previewResolution;
    if (backgroundWidth < canvasWidthInInch * constants.MIN_CANVAS_DPI) {
      lowWidthDpi = true;
    }
  }
  if (!lowHeightDpi) {
    const canvasHeightInInch = canvasData.fullHeight / canvasData.previewResolution;
    if (backgroundHeight < canvasHeightInInch * constants.MIN_CANVAS_DPI) {
      lowHeightDpi = true;
    }
  }

  if (lowWidthDpi || lowHeightDpi) {
    if (!checkOnly)
      dispatch(
        changeLogoEditingStatus({
          currentStatus: constants.logoEditingStatusEnum.DpiWarningPanel,
          isNewUploaded,
          returnStatus,
          newBackgroundImage: imageData,
          isCropBackground,
        })
      );
    return true;
  }

  return false;
};

export const checkResizedLogoDpi = ({ dispatch, canvasData, imageData, newSize, checkOnly }) => {
  if (constants.disableCheckLowDpi) return false;
  if (isVectorImage(imageData.fileName)) return false;

  let isLogoLowDpi = false;
  let logoHighDpiSize = null;

  let lowWidthDpi = false;
  let lowHeightDpi = false;
  const threshold = 1.03; // set a threshold of 1.03 because getLogoSizeByResolution has to round the result

  const logoMaxInchesX = imageData.finalCropRect.width / constants.MIN_CANVAS_DPI;
  const logoInchesX = newSize.width / canvasData.previewResolution;
  if (logoInchesX > logoMaxInchesX && logoInchesX / logoMaxInchesX > threshold) {
    lowWidthDpi = true;
  }

  const logoMaxInchesY = imageData.finalCropRect.height / constants.MIN_CANVAS_DPI;
  const logoInchesY = newSize.height / canvasData.previewResolution;
  if (logoInchesY > logoMaxInchesY && logoInchesY / logoMaxInchesY > threshold) {
    lowHeightDpi = true;
  }

  logoHighDpiSize = {
    width: Math.round(logoInchesX * constants.MIN_CANVAS_DPI),
    height: Math.round(logoInchesY * constants.MIN_CANVAS_DPI),
  };

  if (lowWidthDpi || lowHeightDpi) {
    if (!checkOnly) {
      dispatch(
        changeLogoEditingStatus({
          currentStatus: constants.logoEditingStatusEnum.DpiWarningPanel,
          isNewUploaded: false,
          logoHighDpiSize,
          returnStatus: constants.logoEditingStatusEnum.None,
        })
      );
    }
    isLogoLowDpi = true;
  } else {
    isLogoLowDpi = false;
  }

  return { isLogoLowDpi, logoHighDpiSize };
};

// if changing color/number after sharpen(ScreenPrinted), need to switch to uncolorize
export const switchToUnColorize = (imageData) => {
  if (imageData.sharpenStatus !== constants.imageSharpenStatus.Sharpened) return;

  imageData.pngFileNameList = Object.assign([], imageData.pngFileNameList);
  imageData.cloudResourceIdList = Object.assign([], imageData.cloudResourceIdList);
  if (imageData.removeWhiteOption === constants.removeWhiteMode.None) {
    imageData.pngFileName = imageData.pngFileNameListOfNoColorize[0];
    imageData.cloudResourceId = imageData.cloudResourceIdListOfNoColorize[0];
    imageData.pngFileNameList[0] = imageData.pngFileName;
    imageData.cloudResourceIdList[0] = imageData.cloudResourceId;
    imageData.scene7FileName = imageData.cloudResourceId;
  } else if (imageData.removeWhiteOption === constants.removeWhiteMode.RemoveEdge) {
    imageData.pngFileName = imageData.pngFileNameListOfNoColorize[1];
    imageData.cloudResourceId = imageData.cloudResourceIdListOfNoColorize[1];
    imageData.pngFileNameList[1] = imageData.pngFileName;
    imageData.cloudResourceIdList[1] = imageData.cloudResourceId;
    imageData.scene7FileName = imageData.cloudResourceId;
  } else if (imageData.removeWhiteOption === constants.removeWhiteMode.RemoveAll) {
    imageData.pngFileName = imageData.pngFileNameListOfNoColorize[2];
    imageData.cloudResourceId = imageData.cloudResourceIdListOfNoColorize[2];
    imageData.pngFileNameList[2] = imageData.pngFileName;
    imageData.cloudResourceIdList[2] = imageData.cloudResourceId;
    imageData.scene7FileName = imageData.cloudResourceId;
  }

  imageData.autoCropRect = Object.assign({}, imageData.autoCropRect);
  imageData.cropRect = Object.assign({}, imageData.cropRect);
  imageData.finalCropRect = Object.assign({}, imageData.finalCropRect);
  const rate = imageData.sharpenSizeRate;
  imageData.originalWidth /= rate;
  imageData.originalHeight /= rate;
  imageData.autoCropRect.x /= rate;
  imageData.autoCropRect.y /= rate;
  imageData.autoCropRect.width /= rate;
  imageData.autoCropRect.height /= rate;
  imageData.cropRect.x /= rate;
  imageData.cropRect.y /= rate;
  imageData.cropRect.width /= rate;
  imageData.cropRect.height /= rate;
  imageData.finalCropRect.x /= rate;
  imageData.finalCropRect.y /= rate;
  imageData.finalCropRect.width /= rate;
  imageData.finalCropRect.height /= rate;
  imageData.sharpenSizeRate = 1;
  imageData.sharpenStatus = constants.imageSharpenStatus.Unsharpened;
};

export const switchToUnsharpened = (imageData, studioItemType) => {
  if (imageData.sharpenStatus !== constants.imageSharpenStatus.Unsharpened) return;

  // studioItemType only be provided when clicking "Sharpen" button in screenprinted digital studio
  if (imageData.removeWhiteOption === constants.removeWhiteMode.None) {
    if (studioItemType === studioItemTypeEnum.screenPrintedDigital) {
      imageData.pngFileName = imageData.pngFileNameListOfUnsharpen[0];
      imageData.cloudResourceId = imageData.cloudResourceIdListOfUnsharpen[0];
    } else {
      imageData.pngFileName = imageData.pngFileNameListOfNoColorize[0];
      imageData.cloudResourceId = imageData.cloudResourceIdListOfNoColorize[0];
    }
    imageData.pngFileNameList[0] = imageData.pngFileName;
    imageData.cloudResourceIdList[0] = imageData.cloudResourceId;
    imageData.scene7FileName = imageData.cloudResourceId;
  } else if (imageData.removeWhiteOption === constants.removeWhiteMode.RemoveEdge) {
    if (studioItemType === studioItemTypeEnum.screenPrintedDigital) {
      imageData.pngFileName = imageData.pngFileNameListOfUnsharpen[1];
      imageData.cloudResourceId = imageData.cloudResourceIdListOfUnsharpen[1];
    } else {
      imageData.pngFileName = imageData.pngFileNameListOfNoColorize[1];
      imageData.cloudResourceId = imageData.cloudResourceIdListOfNoColorize[1];
    }
    imageData.pngFileNameList[1] = imageData.pngFileName;
    imageData.cloudResourceIdList[1] = imageData.cloudResourceId;
    imageData.scene7FileName = imageData.cloudResourceId;
  } else if (imageData.removeWhiteOption === constants.removeWhiteMode.RemoveAll) {
    if (studioItemType === studioItemTypeEnum.screenPrintedDigital) {
      imageData.pngFileName = imageData.pngFileNameListOfUnsharpen[2];
      imageData.cloudResourceId = imageData.cloudResourceIdListOfUnsharpen[2];
    } else {
      imageData.pngFileName = imageData.pngFileNameListOfNoColorize[2];
      imageData.cloudResourceId = imageData.cloudResourceIdListOfNoColorize[2];
    }
    imageData.pngFileNameList[2] = imageData.pngFileName;
    imageData.cloudResourceIdList[2] = imageData.cloudResourceId;
    imageData.scene7FileName = imageData.cloudResourceId;
  }

  const rate = imageData.sharpenSizeRate;
  imageData.originalWidth /= rate;
  imageData.originalHeight /= rate;
  imageData.autoCropRect.x /= rate;
  imageData.autoCropRect.y /= rate;
  imageData.autoCropRect.width /= rate;
  imageData.autoCropRect.height /= rate;
  imageData.cropRect.x /= rate;
  imageData.cropRect.y /= rate;
  imageData.cropRect.width /= rate;
  imageData.cropRect.height /= rate;
  imageData.finalCropRect.x /= rate;
  imageData.finalCropRect.y /= rate;
  imageData.finalCropRect.width /= rate;
  imageData.finalCropRect.height /= rate;
  imageData.sharpenSizeRate = 1;
};

export const switchToSharpened = (imageData) => {
  if (imageData.sharpenStatus !== constants.imageSharpenStatus.Sharpened) return;
  imageData.pngFileNameList = Object.assign([], imageData.pngFileNameList);
  imageData.cloudResourceIdList = Object.assign([], imageData.cloudResourceIdList);

  if (imageData.removeWhiteOption === constants.removeWhiteMode.None) {
    imageData.pngFileName = imageData.sharpenedFileAsIs;
    imageData.pngFileNameList[0] = imageData.pngFileName;
    imageData.cloudResourceId = imageData.sharpenedResourceAsIs;
    imageData.cloudResourceIdList[0] = imageData.cloudResourceId;
    imageData.scene7FileName = imageData.cloudResourceId;
  } else if (imageData.removeWhiteOption === constants.removeWhiteMode.RemoveEdge) {
    imageData.pngFileName = imageData.sharpenedFileEdge;
    imageData.pngFileNameList[1] = imageData.pngFileName;
    imageData.cloudResourceId = imageData.sharpenedResourceEdge;
    imageData.cloudResourceIdList[1] = imageData.cloudResourceId;
    imageData.scene7FileName = imageData.cloudResourceId;
  } else if (imageData.removeWhiteOption === constants.removeWhiteMode.RemoveAll) {
    imageData.pngFileName = imageData.sharpenedFileAll;
    imageData.pngFileNameList[2] = imageData.pngFileName;
    imageData.cloudResourceId = imageData.sharpenedResourceAll;
    imageData.cloudResourceIdList[2] = imageData.cloudResourceId;
    imageData.scene7FileName = imageData.cloudResourceId;
  }
  imageData.autoCropRect = Object.assign({}, imageData.autoCropRect);
  imageData.cropRect = Object.assign({}, imageData.cropRect);
  imageData.finalCropRect = Object.assign({}, imageData.finalCropRect);

  const rate = imageData.sharpenSizeRate;
  imageData.originalWidth *= rate;
  imageData.originalHeight *= rate;
  imageData.autoCropRect.x *= rate;
  imageData.autoCropRect.y *= rate;
  imageData.autoCropRect.width *= rate;
  imageData.autoCropRect.height *= rate;
  imageData.cropRect.x *= rate;
  imageData.cropRect.y *= rate;
  imageData.cropRect.width *= rate;
  imageData.cropRect.height *= rate;
  imageData.finalCropRect.x *= rate;
  imageData.finalCropRect.y *= rate;
  imageData.finalCropRect.width *= rate;
  imageData.finalCropRect.height *= rate;
};

// returnStatus - if given, set it to returnStatus property of logoEditingStatus.
// and then this returnStatus will be used in DpiContinue when "Continue As Is" is clicked
export const checkUploadLogoDpi = (dispatch, imageData, returnStatus, checkOnly) => {
  let lowWidthDpi = false;
  let lowHeightDpi = false;

  if (constants.disableCheckLowDpi) return false;
  if (isVectorImage(imageData.fileName)) return false;

  if (Math.ceil(imageData.logoResolutionX) < constants.MIN_CANVAS_DPI) lowWidthDpi = true;
  if (Math.ceil(imageData.logoResolutionY) < constants.MIN_CANVAS_DPI) lowHeightDpi = true;

  //test code
  //if (imageData.originFileName === 'APL.png') {
  //  lowWidthDpi = false;
  //  lowHeightDpi = false;
  //}

  if (lowWidthDpi || lowHeightDpi) {
    if (!checkOnly)
      dispatch(
        changeLogoEditingStatus({
          currentStatus: constants.logoEditingStatusEnum.DpiWarningPanel,
          isNewUploaded: true,
          logoHighDpiSize: null,
          returnStatus: returnStatus || constants.logoEditingStatusEnum.None,
        })
      );
    return true;
  }
  return false;
};

export const validateImageDpiBeforeAddCart = (dispatch, state) => {
  if (constants.disableCheckLowDpi) return true;

  let hasBackgroundLowDpi = false;
  let hasLogoLowDpi = false;
  let pixelMessage = '';

  const logoEditingStatus = getLogoEditingStatus(state).currentStatus;

  if (logoEditingStatus === constants.logoEditingStatusEnum.DpiWarningPanel) {
    dispatch(hideWaitingCover());
    return false;
  }
  if (
    logoEditingStatus === constants.logoEditingStatusEnum.DpiWarningButton ||
    logoEditingStatus === constants.logoEditingStatusEnum.DpiWarningContinueToCart
  ) {
    return true;
  }

  const lowDpiData = { canvasKey: null, lowDpiLogoGuid: -1 };
  const selectedTemplates = getFinalTemplateSelection(state);

  Object.keys(selectedTemplates).some((canvasKey) => {
    const template = selectedTemplates[canvasKey];
    if (template && template.templateType === TemplateType.CUSTOM) {
      const backgroundImage = template;
      const canvasData = getCurrentCanvasData(state, canvasKey);

      if (backgroundImage) {
        const isBackgroundLowDpi = checkBackgroundImageDpi({
          dispatch,
          canvasData,
          imageData: backgroundImage,
          isCropBackground: false,
          checkOnly: true,
        });
        if (isBackgroundLowDpi) {
          lowDpiData.canvasKey = canvasKey;
          hasBackgroundLowDpi = true;
          pixelMessage = getPixelMessage(true, logoEditingStatus.logoHighDpiSize, canvasData);
          return true; // exit loop
        }
      }
    }

    return false; //continue loop
  });

  // check logo dpi only when background is passed, so lowDpiLogoGuid=-1 stands for background
  if (!hasBackgroundLowDpi) {
    const imageDict = state.imageDict;
    Object.keys(imageDict).some((canvasKey) => {
      const canvasData = getCurrentCanvasData(state, canvasKey);
      const imageList = imageDict[canvasKey];

      if (imageList && imageList.length > 0) {
        imageList.some((image) => {
          if (image.data) {
            if (image.data.type === constants.userImageType.UploadLogo) {
              let isLogoLowDpi = false;
              let logoHighDpiSize = null;

              isLogoLowDpi = checkUploadLogoDpi(
                dispatch,
                image.data,
                constants.logoEditingStatusEnum.DpiWarningButton,
                true
              );

              if (!isLogoLowDpi) {
                const checkResult = checkResizedLogoDpi({
                  dispatch,
                  canvasData,
                  imageData: image.data,
                  newSize: { width: image.data.width, height: image.data.height },
                  checkOnly: true,
                });
                isLogoLowDpi = checkResult.isLogoLowDpi;
                logoHighDpiSize = checkResult.logoHighDpiSize;
              }

              if (isLogoLowDpi) {
                lowDpiData.canvasKey = canvasKey;
                lowDpiData.lowDpiLogoGuid = image.ui.guid;
                hasLogoLowDpi = true;
                pixelMessage = getPixelMessage(false, logoHighDpiSize, canvasData);
                return true;
              }
            }
          }
          return false;
        });
      }

      if (hasLogoLowDpi) return true;
      else return false;
    });
  }

  if (hasBackgroundLowDpi || hasLogoLowDpi) {
    if (isMobileOnly) dispatch(setCurrentStep(configuratorStep.lowDpi));

    dispatch(
      switchShowWarningMessageContainer({
        show: true,
        message: [
          `Your ${
            hasBackgroundLowDpi ? 'background' : 'logo/art' //if hasBackgroundLowDpi is true, hasLogoLowDpi will be always false
          } resolution is too low and will appear pixelated or blurry when imprinted.
          Please upload a new image with a 300 DPI${pixelMessage} or higher for the best results.`,
        ],
      })
    );

    // switch to the canvas tab page with invalid background or logos
    dispatch(setCurrentImprintAreaKey(lowDpiData.canvasKey));

    if (hasLogoLowDpi) {
      dispatch(canvasActions.unSelectAllImage({ canvasKey: lowDpiData.canvasKey }));
      dispatch(canvasActions.unSelectAllText({ canvasKey: lowDpiData.canvasKey }));
      dispatch(changeSidebarTabKey(constants.sidebarTabKeyEnum.Logo));
      dispatch(canvasActions.selectImage({ canvasKey: lowDpiData.canvasKey, imageId: lowDpiData.lowDpiLogoGuid }));
    }

    dispatch(hideWaitingCover());

    dispatch(
      changeLogoEditingStatus({
        currentStatus: constants.logoEditingStatusEnum.DpiWarningButton,
        lowDpiData,
      })
    );

    return false;
  }

  return true;
};

export const replaceLowDpiLogo = ({ dispatch, canvasKey, lowDpiLogoGuid }) => {
  if (lowDpiLogoGuid) {
    dispatch(canvasActions.deleteImage({ canvasKey, guid: lowDpiLogoGuid }));

    dispatch(changeLogoEditingStatus({ lowDpiLogoGuid: -1 }));
  }
};

export const getPixelMessage = (isBackground, logoHighDpiSize, canvasData) => {
  let pixels = null;

  if (isBackground)
    pixels = {
      width: Math.round(
        ((canvasData.fullWidth - canvasData.bleedLeft - canvasData.bleedRight) / canvasData.previewResolution) *
          constants.MIN_CANVAS_DPI
      ),
      height: Math.round(
        ((canvasData.fullHeight - canvasData.bleedTop - canvasData.bleedBottom) / canvasData.previewResolution) *
          constants.MIN_CANVAS_DPI
      ),
    };
  else {
    if (logoHighDpiSize)
      pixels = {
        width: logoHighDpiSize.width,
        height: logoHighDpiSize.height,
      };
  }

  return pixels == null ? '' : ' (' + pixels.width + ' x ' + pixels.height + ' pixels)';
};

export const addCartWithLowDpiImage = (dispatch, hasUpsells) => {
  dispatch(showWaitingCover());
  dispatch(goToUpsellOrAddToCart({ hasUpsells }));

  // reset logoEditingStatus after addToCart
  dispatch(changeLogoEditingStatus(constants.logoEditingStatusEnum.None));
  dispatch(switchShowWarningMessageContainer({ show: false }));
};

export const adjustCropParameter = (cropParam, canvasScale) => {
  if (cropParam) {
    cropParam.x = Math.round(cropParam.x / canvasScale);
    cropParam.y = Math.round(cropParam.y / canvasScale);
    cropParam.width = Math.round(cropParam.width / canvasScale);
    cropParam.height = Math.round(cropParam.height / canvasScale);
  }
};
